import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import {catchError, map, switchMap} from 'rxjs/operators';
import {FlightSearchInterface} from "./itinerary-service.service";
import {environment} from "../../environment/environment";
import { ItineraryauthService } from './accounts/itineraryauth.service';


@Injectable({
  providedIn: 'root'
})
export class CustomHttpService {
  public apiUrl = environment.corperate_base_url; // Replace with your API URL
  public itineraryUrl = environment.itinerary_base_url; // Replace with your API URL
  public itineraryProxyUrl = (environment as any).itinerary_base_proxy_url; // Replace with your API URL
  public hotelsApiUrl = (environment as any).hotels_base_url; // Replace with your API URL
  public ticketUrl = `${this.apiUrl}/tickets/`; // Replace with your API URL
  public companytUrl = `${this.apiUrl}/corperates/`; // Replace with your API URL
  public userUrl = `${this.apiUrl}/users/`;//Replace with your API URL
  public ticketUrlApprove = `${this.apiUrl}/tickets/`; // Replace with your API URL
  public reportsUrl = `${this.apiUrl}/reports/`; // Replace with your API URL

  private departmentsSubject = new BehaviorSubject<any[] | null>(null);
  departments$ = this.departmentsSubject.asObservable();

  private usersSubject = new BehaviorSubject<any[] | null>(null);
  users$ = this.usersSubject.asObservable();

  private companiesSubject = new BehaviorSubject<any[] | null>(null);
  companies$ = this.companiesSubject.asObservable();

  //public botUrl = 'https://873ac0381e22.ngrok-free.app'
  
  //public botUrl = 'http://localhost:3978'
  public botUrl = 'https://dev.botservice.buupass.com'


  constructor(
    private http: HttpClient,
    private auth:ItineraryauthService
  ) {

  }
  

 // Fetch a list of all companies
//  getCompanies(): Observable<any[]> {
//   return this.http.get<any[]>(this.companytUrl).pipe(
//     map(response => response),
//     catchError(error => {
//       console.error('Error fetching companies:', error);
//       return throwError(error);
//     })
//   );
// }

// fetch all hotel locations

// getHotelsLocations(): Observable<any[]>{
//   return this.http.get<any[]>(`${this.hotelsApiUrl}/hotels/locations`).pipe(
//     map(response => response),
//     catchError(error => {
//       console.error('Error fetching hotel locations:', error);
//       return throwError(error);
//     })
//   );
// }

getHotelsLocations(): Observable<any[]>{
  return this.auth.getToken().pipe(
    switchMap((token): Observable<any> => {
      let headers = new HttpHeaders()
      headers = headers.append('Authorization', `Bearer ${token}`)
      return this.http
        .get<any[]>(`${this.itineraryUrl}hotels/locations`, {headers:headers})
        .pipe(
          map(response => response),
          catchError(error => {
            console.error('Error fetching hotel locations:', error);
            return throwError(error);
          })
        );
        ;
    })
  )
}

searchHotelLocations(query: string): Observable<any[]> {
  return this.auth.getToken().pipe(
    switchMap((token): Observable<any> => {
      let headers = new HttpHeaders();
      headers = headers.append('Authorization', `Bearer ${token}`);
      const params = new HttpParams().set('q', query);
      return this.http
        .get<any[]>(`${this.itineraryUrl}hotels/locations/search`, { headers, params })
        .pipe(
          map(response => response),
          catchError(error => {
            console.error('Error searching hotel locations:', error);
            return throwError(error);
          })
        );
    })
  );
}

// fetch all hotel filters

getHotelsFilters(): Observable<any[]>{
  return this.auth.getToken().pipe(
    switchMap((token): Observable<any> => {
      let headers = new HttpHeaders()
      headers = headers.append('Authorization', `Bearer ${token}`)
      return this.http
        .get<any[]>(`${this.itineraryUrl}hotels/filters`, {headers:headers})
        .pipe(
          map(response => response),
          catchError(error => {
            console.error('Error fetching hotel filters:', error);
            return throwError(error);
          })
        );
        ;
    })
  )
}

// getHotelsFilters(): Observable<any[]>{
//   return this.http.get<any[]>(`${this.hotelsApiUrl}/hotels/filters`).pipe(
//     map(response => response),
//     catchError(error => {
//       console.error('Error fetching hotel filters:', error);
//       return throwError(error);
//     })
//   );
// }

// searchHotels(data: any): Observable<any[]>{
//   return this.auth.getToken().pipe(
//     switchMap((token): Observable<any> => {
//       let headers = new HttpHeaders()
//       headers = headers.append('Authorization', `Bearer ${token}`)
//       return this.http
//         .post<any>(`${this.hotelsApiUrl}/hotels/availability`, {headers:headers})
//         .pipe(
//           map(response => response),
//           catchError(error => {
//             console.error('Error searching:', error);
//             return throwError(error);
//           })
//         );
//         ;
//     })
//   )
// }

// Search available hotels
searchHotels(data: any, params: any = {}): Observable<any> {
  console.log('search data', data)
  let httpParams = new HttpParams();
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      httpParams = httpParams.set(key, params[key]);
    }
  }
  return this.http.post<any>(`${this.apiUrl}/tickets/v2/bookings/hotels/availability/`, data, {
    params: httpParams,
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  }).pipe(
    map(response => response),
    catchError(error => {
      console.error('Error searching:', error);
      return throwError(error);
    })
  );
}

  searchFlightsV2(data: any): Observable<any> {
    console.log('search flights data', data)
    return this.http.post<any>(`${this.apiUrl}/tickets/v2/bookings/flights/schedules/`, data, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }).pipe(
      map(response => response),
      catchError(error => {
        console.error('Error searching flights:', error);
        return throwError(error);
      })
    );
  }

// Search available hotels
// searchHotelsSrp(data: any): Observable<any> {
//   console.log('search data srp', data)
//   return this.http.post<any>(`${this.itineraryProxyUrl}hotels/srp`, data, {
//     headers: new HttpHeaders({ 'Content-Type': 'application/json' })
//   }).pipe(
//     map(response => response),
//     catchError(error => {
//       console.error('Error searching:', error);
//       return throwError(error);
//     })
//   );
// }

searchHotelsSrp(data: any): Observable<any>{
  return this.auth.getToken().pipe(
    switchMap((token): Observable<any> => {
      let headers = new HttpHeaders()
      headers = headers.append('Authorization', `Bearer ${token}`)
      return this.http
        .post<any>(`${this.itineraryProxyUrl}hotels/srp`, data, {headers:headers})
        .pipe(
          map(response => response),
          catchError(error => {
            console.error('Error searching hotels srp v2', error);
            return throwError(error);
          })
        );
        ;
    })
  )
}


searchHotelDetails(hotelId: any): Observable<any>{
  return this.auth.getToken().pipe(
    switchMap((token): Observable<any> => {
      let headers = new HttpHeaders()
      headers = headers.append('Authorization', `Bearer ${token}`)
      return this.http
        .get<any>(`${this.itineraryUrl}hotels/details/${hotelId}`, {headers:headers})
        .pipe(
          map(response => response),
          catchError(error => {
            console.error('Error searching hotel details', error);
            return throwError(error);
          })
        );
        ;
    })
  )
}

// Search extra detail on hotel by ID
// searchHotelDetails(hotelId: any): Observable<any> {
//   console.log('search hotelId', hotelId)
//   return this.http.get<any>(`${this.itineraryUrl}/api/v1/hotels/details/${hotelId}`).pipe(
//     map(response => response),
//     catchError(error => {
//       console.error('Error searching details:', error);
//       return throwError(error);
//     })
//   );
// }

// fetch all pending approvals v2

getPendingApprovalsV2(channel: any = {}): Observable<any[]>{
  console.log('channel', channel)
  return this.http.get<any[]>(`${this.ticketUrlApprove}v2/pending-approvals/${channel === 'car-hire'?'?channel=car-hire': channel === 'hotels'?'?channel=hotels' :''}`).pipe(
    map(response => response),
    catchError(error => {
      console.error('Error fetching pending approvals:', error);
      return throwError(error);
    })
  );
}

// fetch all pending approvals

getPendingApprovals(params: any = {}): Observable<any[]>{
  let httpParams = new HttpParams();
  for (const key in params) { 
    if (params.hasOwnProperty(key)) {
      httpParams = httpParams.set(key, params[key]);
    }
  }
  return this.http.get<any[]>(`${this.ticketUrlApprove}pendingapprovals`).pipe(
    map(response => response),
    catchError(error => {
      console.error('Error fetching pending approvals:', error);
      return throwError(error);
    })
  );
}

// fetch all pending approvals

getReports(
  params: any = {}, 
  startDate: any, 
  endDate: any,
  companyId: string,
  departmenId: string,
  status: string,
  channel: string
): Observable<any>{
  let httpParams = new HttpParams();
  // console.log('pagination val', params)
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      httpParams = httpParams.set(key, params[key]);
    }
  }
  return this.http.get<any>(
    `${this.reportsUrl}tickets/?page=${params}&start_date=${startDate}&end_date=${endDate}&company_id=${companyId}&department_id=${departmenId}&booking_status=${status}&booking_channel=${channel}`
  ).pipe(
    map(response => response),
    catchError(error => {
      console.error('Error fetching reports:', error);
      return throwError(error);
    })
  );
}

getReportsCsv(
  params: any = {},
  startDate: any, 
  endDate: any,
  companyId: string,
  departmenId: string,
  status: string,
  channel: string
): Observable<string>{
  let httpParams = new HttpParams();
  // console.log('pagination val', params)
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      httpParams = httpParams.set(key, params[key]);
    }
  }
  return this.http.get<any>(
    `${this.reportsUrl}tickets/export_csv/?start_date=${startDate}&end_date=${endDate}&company_id=${companyId}&department_id=${departmenId}&booking_status=${status}&booking_channel=${channel}`,
    { responseType: 'text' as 'json'}
  ).pipe(
    map(response => response),
    catchError(error => {
      console.error('Error report csv data', error);
      return throwError(error);
    })
  );
}


fetchUsersV2(params: any = {}): void {
  if (!this.usersSubject.value) {
    let httpParams = new HttpParams();
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        httpParams = httpParams.set(key, params[key]);
      }
    }
    this.http.get<any[]>(`${this.userUrl}v2/list-approvers`, { params: httpParams }).pipe(
      catchError(error => {
        console.error('Error fetching users:', error);
        return throwError(() => error);
      })
    ).subscribe(users => {
      console.log('fetched users', users)
      return this.usersSubject.next(users)
    });
  }
}

// Fetch a list of all users
getUsersV2(params: any = {}): Observable<any[]> {
  let httpParams = new HttpParams();
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      httpParams = httpParams.set(key, params[key]);
    }
  }
  return this.http.get<any[]>(`${this.userUrl}v2/list-approvers`, { params: httpParams }).pipe(
    map(response => response),
    catchError(error => {
      console.error('Error fetching users:', error);
      return throwError(error);
    })
  );
}

  // Fetch a list of all users
getUsers(params: any = {}): Observable<any[]> {
  let httpParams = new HttpParams();
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      httpParams = httpParams.set(key, params[key]);
    }
  }
  return this.http.get<any[]>(this.userUrl, { params: httpParams }).pipe(
    map(response => response),
    catchError(error => {
      console.error('Error fetching users:', error);
      return throwError(error);
    })
  );
}

   // Fetch a specific user by ID
   getUserById(userId: string): Observable<any> {
    // Trailing slash matters here — updateUser() below uses one for the same resource.
    // Without it, Django's APPEND_SLASH redirects the GET server-side, which can surface
    // in the browser as a second, indefinitely-pending request to the slashed URL.
    return this.http.get<any>(`${this.userUrl}${userId}/`).pipe(
      map(response => response),
      catchError(error => {
        console.error('Error fetching user by ID:', error);
        return throwError(error);
      })
    );
  }

  createProxyUser(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/corperates/proxy-users/manage/`, data).pipe(
      map(response => response),
      catchError(error => {
        console.error('Error creating proxy:', error);
        return throwError(error);
      })
    );
  }

  updateProxyUser(data: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/corperates/proxy-users/manage/`, data).pipe(
      map(response => response),
      catchError(error => {
        console.error('Error creating proxy:', error);
        return throwError(error);
      })
    );
  }

  deleteProxyUser(data: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/corperates/proxy-users/manage/`, data).pipe(
      map(response => response),
      catchError(error => {
        console.error('Error creating proxy:', error);
        return throwError(error);
      })
    );
  }

  getProxyUsers(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/corperates/proxy-users/manage/`).pipe(
      map(response => response),
      catchError(error => {
        console.error('Error creating proxy:', error);
        return throwError(error);
      })
    );
  }

  getBookableUserList(){
      return this.http.get<any>(`${this.apiUrl}/corperates/proxy-users/list/`).pipe(
      map(response => response),
      catchError(error => {
        console.error('Error fetching bookable user list', error);
        return throwError(error);
      })
    );
  }

  // Create a new user
  createUser(data: any): Observable<any> {
    return this.http.post<any>(this.userUrl, data).pipe(
      map(response => response),
      catchError(error => {
        console.error('Error creating user:', error);
        return throwError(error);
      })
    );
  }

  // Update an existing user by ID
updateUser(userId: string, data: any): Observable<any> {
  // Construct the endpoint with a trailing slash after the user ID
  const url = `${this.userUrl}${userId}/`;

  // Optionally, add custom headers (e.g., if authentication is needed)
  const headers = new HttpHeaders({
    'Content-Type': 'application/json',
    // Add authentication header if required:
    // 'Authorization': `Bearer ${authToken}`
  });

  console.log('Updating user at URL:', url); // For debugging
  console.log('Payload:', data); // Log the data being sent

  return this.http.patch<any>(url, data, { headers }).pipe(
    map(response => {
      console.log('User updated successfully:', response);
      return response;
    }),
    catchError(error => {
      console.error('Error updating user:', error);
      return throwError(error);
    })
  );
}

  // Cancel ticket
cancelTicket(ticketId: string): Observable<any> {
  // Construct the endpoint with a trailing slash after the user ID
  const url = `${this.ticketUrl}${ticketId}/self-cancel/`;

  // Optionally, add custom headers (e.g., if authentication is needed)
  const headers = new HttpHeaders({
    'Content-Type': 'application/json',
    // Add authentication header if required:
    // 'Authorization': `Bearer ${authToken}`
  });

  return this.http.patch<any>(url, {}, { headers }).pipe(
    map(response => {
      console.log('cancel ticket:', response);
      return response;
    }),
    catchError(error => {
      console.error('Error cancel:', error);
      return throwError(error);
    })
  );
}

getCompaniesV2(params: any = {}): void {
  if (!this.companiesSubject.value) {
    let httpParams = new HttpParams();
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        httpParams = httpParams.set(key, params[key]);
      }
    }
    
    this.http.get<any[]>(`${this.apiUrl}/corperates/v2/list-child-companies`, { params: httpParams }).pipe(
      catchError(error => {
        console.error('Error fetching companies:', error);
        return throwError(() => error);
      })
    ).subscribe(companies => {
      console.log('fetched companies', companies)
      return this.companiesSubject.next(companies)
    });
  }
}


//GET all child companies section
// getCompaniesV2(params: any = {}): Observable<any[]> {
//   let httpParams = new HttpParams();
//   for (const key in params) {
//     if (params.hasOwnProperty(key)) {
//       httpParams = httpParams.set(key, params[key]);
//     }
//   }
//   return this.http.get<any[]>(`${this.apiUrl}/corperates/v2/list-child-companies`, { params: httpParams }).pipe(
//     map(response => response),
//     catchError(error => {
//       console.error('Error fetching companies:', error);
//       return throwError(error);
//     })
//   );
// }

//Companies section
getCompanies(params: any = {}): Observable<any[]> {
  let httpParams = new HttpParams();
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      httpParams = httpParams.set(key, params[key]);
    }
  }
  return this.http.get<any[]>(this.companytUrl, { params: httpParams }).pipe(
    map(response => response),
    catchError(error => {
      console.error('Error fetching companies:', error);
      return throwError(error);
    })
  );
}

   // Fetch a specific company by ID

   getCompanyById(companyId: string): Observable<any> {
    return this.http.get<any>(`${this.companytUrl}${companyId}/`).pipe(
      map(response => response),
      catchError(error => {
        console.error('Error fetching company by ID:', error);
        return throwError(error);
      })
    );
  }

  // Create a new company

  createCompany(data: any): Observable<any> {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      console.log(`Appending: ${key} = ${data[key]}`); // Debug each field
      formData.append(key, data[key]);
    });
  
    return this.http.post<any>(this.companytUrl, formData).pipe(
      map((response) => response),
      catchError((error) => {
        console.error('Error creating company:', error);
        return throwError(() => new Error('Failed to create company. Please try again.'));
      })
    );
  }
  
  // Update an existing company by ID

  updateCompany(companyId: string, data: any): Observable<any> {
    return this.http.put<any>(`${this.companytUrl}${companyId}/`, data).pipe(
      map(response => response),
      catchError(error => {
        console.error('Error updating company:', error);
        return throwError(error);
      })
    );
  }

  //delete company
  deleteCompany(companyId: string): Observable<any> {
    return this.http.delete<any>(`${this.companytUrl}${companyId}/`).pipe(
      map(response => response),
      catchError(error => {
        console.error('Error deleting company:', error);
        return throwError(error);
      })
    );
  }

  createDesignation(data: any): Observable<any> {
    // const formData = new FormData();
    // Object.keys(data).forEach((key) => {
    //   console.log(`Appending: ${key} = ${data[key]}`); // Debug each field
    //   formData.append(key, data[key]);
    // });
    let designationUrl = `${this.companytUrl}designations/`
    return this.http.post<any>(designationUrl, data).pipe(
      map((response) => response),
      catchError((error) => {
        console.error('Error creating company:', error);
        return throwError(() => new Error('Failed to create company. Please try again.'));
      })
    );
  }

  getDesignations(params: any = {}): Observable<any[]> {
    let httpParams = new HttpParams();
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        httpParams = httpParams.set(key, params[key]);
      }
    }
    return this.http.get<any[]>(`${this.companytUrl}designations/`, { params: httpParams }).pipe(
      map(response => response),
      catchError(error => {
        console.error('Error fetching companies:', error);
        return throwError(error);
      })
    );
  }


  // Fetch a list of all departments
  getDepartmentsV2(params: any = {}): any {
    if (!this.departmentsSubject.value) {
      // only call API if not already loaded
      let httpParams = new HttpParams();
      for (const key in params) {
        if (params.hasOwnProperty(key)) {
          httpParams = httpParams.set(key, params[key]);
        }
      }

      this.http.get<any[]>(`${this.apiUrl}/corperates/departments/v2/list-departments`, { params: httpParams }).pipe(
        catchError(error => {
          console.error('Error fetching departments:', error);
          return throwError(() => error);
        })
      ).subscribe(depts => {
        console.log('fetched Departments', depts)
        return this.departmentsSubject.next(depts)
      });
    }
  }

  // getDepartmentsV2(params: any = {}): Observable<any[]> {
  //   let httpParams = new HttpParams();
  //   for (const key in params) {
  //     if (params.hasOwnProperty(key)) {
  //       httpParams = httpParams.set(key, params[key]);
  //     }
  //   }
  //   return this.http.get<any[]>(`${this.apiUrl}/corperates/departments/v2/list-departments`, { params: httpParams }).pipe(
  //     map(response => response),
  //     catchError(error => {
  //       console.error('Error fetching departments:', error);
  //       return throwError(error);
  //     })
  //   );
  // }
  // Fetch a list of all departments
getDepartments(params: any = {}): Observable<any[]> {
  let httpParams = new HttpParams();
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      httpParams = httpParams.set(key, params[key]);
    }
  }
  return this.http.get<any[]>(`${this.apiUrl}/corperates/departments/`, { params: httpParams }).pipe(
    map(response => response),
    catchError(error => {
      console.error('Error fetching departments:', error);
      return throwError(error);
    })
  );
}
getDepartmentsAll(params: any = {}): Observable<any[]> {
  let httpParams = new HttpParams();
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      httpParams = httpParams.set(key, params[key]);
    }
  }
  return this.http.get<any[]>(`${this.apiUrl}/corperates/departments/v2/all`, { params: httpParams }).pipe(
    map(response => response),
    catchError(error => {
      console.error('Error fetching all departments:', error);
      return throwError(error);
    })
  );
}

// Fetch a specific department by ID
getDepartmentById(departmentId: string): Observable<any> {
  return this.http.get<any>(`${this.apiUrl}/corperates/departments/${departmentId}/`).pipe(
    map(response => response),
    catchError(error => {
      console.error('Error fetching department by ID:', error);
      return throwError(error);
    })
  );
}

// Create a new department
createToken(data: any = {}): Observable<any> {
  return this.http.post<any>(`${this.botUrl}/api/directline/token`, data).pipe(
    map((response) => response),
    catchError((error) => {
      console.error('Error fetching token:', error);
      return throwError(() => new Error('Failed to fetching token. Please try again.'));
    })
  );
}

// Create a new department
createDepartment(data: any): Observable<any> {
  return this.http.post<any>(`${this.apiUrl}/corperates/departments/`, data).pipe(
    map((response) => response),
    catchError((error) => {
      console.error('Error creating department:', error);
      return throwError(() => new Error('Failed to create department. Please try again.'));
    })
  );
}

// Update an existing department by ID
updateDepartment(departmentId: string, data: any): Observable<any> {
  return this.http.put<any>(`${this.apiUrl}/corperates/departments/${departmentId}/`, data).pipe(
    map(response => response),
    catchError(error => {
      console.error('Error updating department:', error);
      return throwError(error);
    })
  );
}

// Delete a department by ID
deleteDepartment(departmentId: string): Observable<any> {
  return this.http.delete<any>(`${this.apiUrl}/corperates/departments/${departmentId}/`).pipe(
    map(response => response),
    catchError(error => {
      console.error('Error deleting department:', error);
      return throwError(error);
    })
  );
}

updateDepartmentV2(departmentId: string, data: any): Observable<any> {
  return this.http.put<any>(`${this.apiUrl}/corperates/departments/v2/${departmentId}/`, data).pipe(
    map(response => response),
    catchError(error => {
      console.error('Error updating department (v2):', error);
      return throwError(error);
    })
  );
}

deleteDepartmentV2(departmentId: string): Observable<any> {
  return this.http.delete<any>(`${this.apiUrl}/corperates/departments/v2/${departmentId}/`).pipe(
    map(response => response),
    catchError(error => {
      console.error('Error deleting department (v2):', error);
      return throwError(error);
    })
  );
}

// Fetch a list of all groups
getGroups(params: any = {}): Observable<any[]> {
  let httpParams = new HttpParams();
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      httpParams = httpParams.set(key, params[key]);
    }
  }
  return this.http.get<any[]>(`${this.apiUrl}/corperates/groups/`, { params: httpParams }).pipe(
    map(response => response),
    catchError(error => {
      console.error('Error fetching groups:', error);
      return throwError(error);
    })
  );
}

// Fetch a specific group by ID
getGroupById(groupId: string): Observable<any> {
  return this.http.get<any>(`${this.apiUrl}/corperates/groups/${groupId}/`).pipe(
    map(response => response),
    catchError(error => {
      console.error('Error fetching group by ID:', error);
      return throwError(error);
    })
  );
}

// Create a new group
createGroup(data: any): Observable<any> {
  return this.http.post<any>(`${this.apiUrl}/corperates/groups/`, data).pipe(
    map((response) => response),
    catchError((error) => {
      console.error('Error creating group:', error);
      return throwError(() => new Error('Failed to create group. Please try again.'));
    })
  );
}

// Update an existing group by ID
updateGroup(groupId: string, data: any): Observable<any> {
  return this.http.put<any>(`${this.apiUrl}/corperates/groups/${groupId}/`, data).pipe(
    map(response => response),
    catchError(error => {
      console.error('Error updating group:', error);
      return throwError(error);
    })
  );
}

// Delete a group by ID
deleteGroup(groupId: string): Observable<any> {
  return this.http.delete<any>(`${this.apiUrl}/corperates/groups/${groupId}/`).pipe(
    map(response => response),
    catchError(error => {
      console.error('Error deleting group:', error);
      return throwError(error);
    })
  );
}

// Fetch all roles
getRoles(params: any = {}): Observable<any[]> {
  let httpParams = new HttpParams();
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      httpParams = httpParams.set(key, params[key]);
    }
  }
  return this.http.get<any[]>(`${this.apiUrl}/corperates/roles/`, { params: httpParams }).pipe(
    map(response => response),
    catchError(error => {
      console.error('Error fetching roles:', error);
      return throwError(error);
    })
  );
}

// Fetch a specific role by ID
getRoleById(roleId: string): Observable<any> {
  return this.http.get<any>(`${this.apiUrl}/corperates/roles/${roleId}/`).pipe(
    map(response => response),
    catchError(error => {
      console.error('Error fetching role by ID:', error);
      return throwError(error);
    })
  );
}

// Create a new role
createRole(data: any): Observable<any> {
  return this.http.post<any>(`${this.apiUrl}/corperates/roles/`, data).pipe(
    map((response) => response),
    catchError((error) => {
      console.error('Error creating role:', error);
      return throwError(error);
    })
  );
}


// Update an existing role by ID
updateRole(roleId: string, data: any): Observable<any> {
  return this.http.put<any>(`${this.apiUrl}/corperates/roles/${roleId}/`, data).pipe(
    map(response => response),
    catchError(error => {
      console.error('Error updating role:', error);
      return throwError(error);
    })
  );
}

// Delete a role by ID
deleteRole(roleId: string): Observable<any> {
  return this.http.delete<any>(`${this.apiUrl}/corperates/roles/${roleId}/`).pipe(
    map(response => response),
    catchError(error => {
      console.error('Error deleting role:', error);
      return throwError(error);
    })
  );
}

// Fetch approval stages for a specific company
getApprovalStages(companyId: string): Observable<any[]> {
  const url = `${this.companytUrl}${companyId}/approval-stages/`;
  console.log('Fetching approval stages from:', url); // Debugging purpose
  return this.http.get<any[]>(url).pipe(
    map((response) => {
      console.log('Approval stages fetched successfully:', response);
      return response;
    }),
    catchError((error) => {
      console.error('Error fetching approval stages:', error);
      return throwError(
        () => new Error('Failed to fetch approval stages. Please try again.')
      );
    })
  );
}

// Create an approval stage for a specific company
createApprovalStage(companyId: string, approvalStageData: any): Observable<any> {
  const url = `${this.companytUrl}${companyId}/approval-stages/`;
  console.log('Creating approval stage at:', url); // Debugging purpose
  console.log('Approval stage data:', approvalStageData); // Debugging purpose
  
  return this.http.post<any>(url, approvalStageData).pipe(
    map((response) => {
      console.log('Approval stage created successfully:', response);
      return response;
    }),
    catchError((error) => {
      console.error('Error creating approval stage:', error);
      return throwError(() => new Error('Failed to create approval stage. Please try again.'));
    })
  );
}

// Reorder approval stages for a specific company
reorderApprovalStages(companyId: string, reorderData: any): Observable<any> {
  const url = `${this.companytUrl}${companyId}/approval-stages/reorder/`;
  console.log('Reordering approval stages at:', url); // Debugging purpose
  console.log('Reorder data:', reorderData); // Debugging purpose

  return this.http.patch<any>(url, reorderData).pipe(
    map((response) => {
      console.log('Approval stages reordered successfully:', response);
      return response;
    }),
    catchError((error) => {
      console.error('Error reordering approval stages:', error);
      return throwError(() => new Error('Failed to reorder approval stages. Please try again.'));
    })
  );
}

// Fetch a specific approval stage by company ID and stage ID
getApprovalStageById(companyId: string, stageId: string): Observable<any> {
  const url = `${this.companytUrl}${companyId}/approval-stages/${stageId}/`;
  console.log('Fetching approval stage from:', url); // Debugging purpose

  return this.http.get<any>(url).pipe(
    map((response) => {
      console.log('Approval stage fetched successfully:', response);
      return response;
    }),
    catchError((error) => {
      console.error('Error fetching approval stage:', error);
      return throwError(() => new Error('Failed to fetch approval stage. Please try again.'));
    })
  );
}

// Update a specific approval stage by company ID and stage ID
patchApprovalStage(companyId: string, stageId: string, updateData: any): Observable<any> {
  const url = `${this.companytUrl}${companyId}/approval-stages/${stageId}/`;
  console.log('Patching approval stage at:', url);
  console.log('Patch data:', updateData);

  return this.http.patch<any>(url, updateData).pipe(
    map((response) => {
      console.log('Approval stage patched successfully:', response);
      return response;
    }),
    catchError((error) => {
      console.error('Error patching approval stage:', error);
      return throwError(() => new Error('Failed to patch approval stage. Please try again.'));
    })
  );
}

updateApprovalStage(companyId: string, stageId: string, updateData: any): Observable<any> {
  const url = `${this.companytUrl}${companyId}/approval-stages/${stageId}/`;
  console.log('Updating approval stage at:', url);
  console.log('Update data:', updateData);

  return this.http.put<any>(url, updateData).pipe(
    map((response) => {
      console.log('Approval stage updated successfully:', response);
      return response;
    }),
    catchError((error) => {
      console.error('Error updating approval stage:', error);
      return throwError(() => new Error('Failed to update approval stage. Please try again.'));
    })
  );
}


// Delete a specific approval stage by company ID and stage ID
deleteApprovalStage(companyId: string, stageId: string): Observable<any> {
  const url = `${this.companytUrl}${companyId}/approval-stages/${stageId}/`;
  console.log('Deleting approval stage at:', url); // Debugging purpose

  return this.http.delete<any>(url).pipe(
    map((response) => {
      console.log('Approval stage deleted successfully:', response);
      return response;
    }),
    catchError((error) => {
      console.error('Error deleting approval stage:', error);
      return throwError(() => new Error('Failed to delete approval stage. Please try again.'));
    })
  );
}


  post<T>(endpoint: string, data: any): Observable<T> {
    return this.http.post<T>(`${this.apiUrl}/${endpoint}`, data);
  }

  get(endpoint: string, data: any): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${endpoint}`, data);
  }


  getTrips(data:any = {}): Observable<any[]>{
    let params = new HttpParams();
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        params = params.set(key, data[key]);
      }
    }
    return this.http
      .get(this.ticketUrl, { params: params })
      .pipe(map((data: any) => {
        return data
      }));
  }

  getBalance(companyID:any):Observable<any>{
    if (!companyID) {
      // No identity to build the URL from yet (e.g. right after login/refresh before
      // the new token has landed) — skip the call instead of hitting /corperates/undefined.
      return of(null);
    }
    // Trailing slash matters here — every other /corperates/{id} call in this service
    // (getCompanyById, updateCompany, deleteCompany) uses one. Without it, Django's
    // APPEND_SLASH redirects the GET server-side, which can surface in the browser as
    // a second, indefinitely-pending request to the slashed URL alongside the original.
    return this.http.get(`${this.companytUrl}${companyID}/`).pipe(map(
      (data:any)=>{
        return data
      }
    ))
  }

  approve(ticketId:string, data = {}) {
      return this.http
        .post(`${this.ticketUrl}${ticketId}/v2/approve/`, data)
        .pipe(map((data:any) =>{
           return data
        }))
  }

  approveV2<T>(ticketId: string, data: any, authToken: string): Observable<T> {
    let headers = new HttpHeaders()
    headers = headers.append('Authorization', `${authToken}`)
    return this.http
      .post<T>(`${this.ticketUrl}${ticketId}/v2/approve/`, data, {headers:headers})
      .pipe(map((data: any) => {
        return data
      }))
      ;
  }

  completeApprovalV2<T>(ticketId: string, data: any, authToken: string): Observable<T> {
    let headers = new HttpHeaders()
    headers = headers.append('Authorization', `${authToken}`)
    return this.http
      .post<T>(`${this.ticketUrl}v2/bookings/${ticketId}/confirm/`, data, {headers:headers})
      .pipe(map((data: any) => {
        return data
      }))
      ;
  }

  reject(ticketId:string, data = {}) {
    return this.http
      .post(`${this.ticketUrl}${ticketId}/v2/approve/`, data)
      .pipe(map((data:any) =>{
        return data
      }))
  }

  // Create a new flight policy
  createFlightPolicy(data: any): Observable<any> {
    const url = `${this.apiUrl}/corperates/policies/type/flights/`;
    console.log('Creating flight policy at:', url);
    console.log('Policy data:', data);

    return this.http.post<any>(url, data).pipe(
      map((response) => {
        console.log('Flight policy created successfully:', response);
        return response;
      }),
      catchError((error) => {
        console.error('Error creating flight policy:', error);
        return throwError(() => new Error('Failed to create flight policy. Please try again.'));
      })
    );
  }

  // Get all flight policies
  getFlightPolicies(): Observable<any[]> {
    const url = `${this.apiUrl}/corperates/policies/type/flights/`;
    console.log('Fetching flight policies from:', url);

    return this.http.get<any[]>(url).pipe(
      map((response) => {
        console.log('Flight policies fetched successfully:', response);
        return response;
      }),
      catchError((error) => {
        console.error('Error fetching flight policies:', error);
        return throwError(() => new Error('Failed to fetch flight policies. Please try again.'));
      })
    );
  }

  // Get all hotel policies
  getHotelPolicies(): Observable<any[]> {
    const url = `${this.apiUrl}/corperates/policies/type/hotels/`;
    console.log('Fetching hotel policies from:', url);

    return this.http.get<any[]>(url).pipe(
      map((response) => {
        console.log('Hotel policies fetched successfully:', response);
        return response;
      }),
      catchError((error) => {
        console.error('Error fetching hotel policies:', error);
        return throwError(() => new Error('Failed to fetch hotel policies. Please try again.'));
      })
    );
  }

  // Delete a flight policy by ID
  deleteFlightPolicy(policyId: string): Observable<any> {
    const url = `${this.apiUrl}/corperates/policies/${policyId}/`;
    console.log('Deleting flight policy at:', url);

    return this.http.delete<any>(url).pipe(
      map((response) => {
        console.log('Flight policy deleted successfully:', response);
        return response;
      }),
      catchError((error) => {
        console.error('Error deleting flight policy:', error);
        return throwError(() => new Error('Failed to delete flight policy. Please try again.'));
      })
    );
  }

  // Update an existing flight policy by ID
  updateFlightPolicy(policyId: string, data: any): Observable<any> {
    const url = `${this.apiUrl}/corperates/policies/${policyId}/`;
    console.log('Updating flight policy at:', url);
    console.log('Policy data:', data);

    return this.http.put<any>(url, data).pipe(
      map((response) => {
        console.log('Flight policy updated successfully:', response);
        return response;
      }),
      catchError((error) => {
        console.error('Error updating flight policy:', error);
        return throwError(() => new Error('Failed to update flight policy. Please try again.'));
      })
    );
  }

  // Create a new hotel policy
  createHotelPolicy(data: any): Observable<any> {
    const url = `${this.apiUrl}/corperates/policies/type/hotels/`;
    console.log('Creating hotel policy at:', url);
    console.log('Policy data:', data);

    return this.http.post<any>(url, data).pipe(
      map((response) => {
        console.log('Hotel policy created successfully:', response);
        return response;
      }),
      catchError((error) => {
        console.error('Error creating hotel policy:', error);
        return throwError(() => new Error('Failed to create hotel policy. Please try again.'));
      })
    );
  }

  // Update an existing hotel policy by ID
  updateHotelPolicy(policyId: string, data: any): Observable<any> {
    const url = `${this.apiUrl}/corperates/policies/${policyId}/`;
    console.log('Updating hotel policy at:', url);
    console.log('Policy data:', data);

    return this.http.put<any>(url, data).pipe(
      map((response) => {
        console.log('Hotel policy updated successfully:', response);
        return response;
      }),
      catchError((error) => {
        console.error('Error updating hotel policy:', error);
        return throwError(() => new Error('Failed to update hotel policy. Please try again.'));
      })
    );
  }

}
